import {
  buildEventStreamPath,
  mergeThreadEvent,
  needsSnapshotRefresh,
  scheduleThreadSnapshotRefresh,
  stopThreadComponentLive
} from "./live-shared.js";
import { startHarnessThreadComponentLive } from "./harness/live.js";
import { startLLMThreadComponentLive } from "./llm/live.js";

export {
  buildEventStreamPath,
  mergeThreadEvent,
  needsSnapshotRefresh,
  scheduleThreadSnapshotRefresh,
  stopThreadComponentLive
} from "./live-shared.js";

export function startThreadComponentLive(state, apiKey, threadID, options = {}) {
  return String(state.thread?.mode || "").trim().toLowerCase() === "llm"
    ? startLLMThreadComponentLive(state, apiKey, threadID, options)
    : startHarnessThreadComponentLive(state, apiKey, threadID, options);
}
